import { render, staticRenderFns } from "./PurchaseRequisitionCreateView.vue?vue&type=template&id=060b3e51"
import script from "./PurchaseRequisitionCreateView.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisitionCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports